export class ChiefComplaintAnswer {
  constructor(title, priority, note, rank, chiefComplaintId, id) {
    this.title = title;
    this.priority = priority;
    this.note = note;
    this.rank = rank;
    this.chiefComplaintId = chiefComplaintId;
    this.id = id;
  }
}
import AnswerDTOMixin from '@/Mixins/BaseInformation/ChiefComplaint/dto/Answer.dto';
export default {
  inject: ['load'],
  data() {
    return {
      allAnswersList: [],
      allActiveAnswersList: [],
      chiefComplaintAnswer: new ChiefComplaintAnswer('', null, null, null, null, -1),
    };
  },
  mixins: [AnswerDTOMixin],
  methods: {
    getAllAnswersFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      const params = {
        ChiefComplaintId: +this.$route.params.id || id,
      };
      this.$store.dispatch('getAllAnswers', params).then(() => {
        if (this.$store.state.chiefComplaintAnswerModule.successFlag) {
          const data = this.$store.state.chiefComplaintAnswerModule.allAnswers;
          this.allAnswersList = this.transformedALlAnswersList([...data]);
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chiefComplaintAnswerModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllAnswersFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.chiefComplaintAnswerModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllAnswersFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllActiveAnswersHandler: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      const params = {
        ChiefComplaintId: +this.$route.params.id || id,
      };
      this.$store.dispatch('getAllActiveAnswers', params).then(() => {
        if (this.$store.state.chiefComplaintAnswerModule.successFlag) {
          const data = this.$store.state.chiefComplaintAnswerModule.allActiveAnswers;
          this.allActiveAnswersList = this.transformedALlAnswersList([...data]);

          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chiefComplaintAnswerModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllAnswersFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.chiefComplaintAnswerModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllAnswersFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAnswerHandler: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      const params = {
        chiefComplaintTriageAnswerId: id,
      };
      this.$store.dispatch('getAnswer', params).then(() => {
        if (this.$store.state.chiefComplaintAnswerModule.successFlag) {
          let data = this.$store.state.chiefComplaintAnswerModule.answer;
          this.chiefComplaintAnswer = this.getAnswer(data);
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chiefComplaintAnswerModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAnswerHandler(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.chiefComplaintAnswerModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAnswerHandler(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    createAnswerHandler: function () {
      if (this.onModalValidation()) {
        if (!this.load.val) {
          this.load.val = true;
        }
        this.$store.dispatch('createAnswer', this.chiefComplaintAnswer).then(() => {
          if (this.$store.state.chiefComplaintAnswerModule.successFlag) {
            this.showAddEditModal = false;
            this.disabelConfirm = false;
            this.snackText = 'پاسخ جدید با موفقیت ایجاد شد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
            this.resetAnswer();
            if (this.load.val) {
              this.load.val = false;
            }
            this.getAllAnswersFunction();
          } else {
            this.disabelConfirm = false;
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.chiefComplaintAnswerModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.createAnswerHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintAnswerModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.createAnswerHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
      }
    },
    editAnswerHandler: function () {
      if (this.onModalValidation()) {
        this.chiefComplaintAnswer.id = this.selectedAnswer;
        if (!this.load.val) {
          this.load.val = true;
        }
        this.$store.dispatch('editAnswer', this.chiefComplaintAnswer).then(() => {
          if (this.$store.state.chiefComplaintAnswerModule.successFlag) {
            this.showAddEditModal = false;
            if (this.load.val) {
              this.load.val = false;
            }
            this.getAllAnswersFunction();
            this.snackText = 'پاسخ با موفقیت ویرایش شد.';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
            this.resetAnswer();
          } else {
            // this.disabelConfirm = false;
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.chiefComplaintAnswerModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.editAnswerHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintAnswerModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.editAnswerHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
      }
    },
    deleteAnswerHandler: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      const params = {
        chiefComplaintTriageAnswerId: id,
      };
      this.$store
        .dispatch('deleteAnswer', params)
        .then(() => {
          if (this.$store.state.chiefComplaintAnswerModule.successFlag) {
            this.disabelConfirm = false;
            // this.$refs.confirm.showConfirmDialog = false;
            this.snackText = 'پاسخ مورد نظر با موفقیت حذف شد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
            if (this.load.val) {
              this.load.val = false;
            }
            this.getAllAnswersFunction();
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.chiefComplaintAnswerModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.deleteAnswerHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintAnswerModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.deleteAnswerHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.disabelConfirm = true));
    },
    activeAnswerHandler: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      const params = {
        chiefComplaintTriageAnswerId: id,
      };
      this.$store
        .dispatch('activeAnswer', params)
        .then(() => {
          if (this.$store.state.chiefComplaintAnswerModule.successFlag) {
            this.disabelConfirm = false;
            // this.$refs.confirm.showConfirmDialog = false;
            this.snackText = 'وضعیت سوال مورد نظر به فعال تغییر یافت';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
            if (this.load.val) {
              this.load.val = false;
            }
            this.getAllAnswersFunction();
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.chiefComplaintAnswerModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.deleteAnswerHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintAnswerModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.deleteAnswerHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.disabelConfirm = true));
    },
    deactiveAnswerHandler: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      const params = {
        chiefComplaintTriageAnswerId: id,
      };
      this.$store
        .dispatch('deactivateAnswer', params)
        .then(() => {
          if (this.$store.state.chiefComplaintAnswerModule.successFlag) {
            this.disabelConfirm = false;
            // this.$refs.confirm.showConfirmDialog = false;
            this.snackText = 'وضعیت سوال مورد نظر به غیر فعال تغییر یافت';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
            if (this.load.val) {
              this.load.val = false;
            }
            this.getAllAnswersFunction();
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.chiefComplaintAnswerModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.deleteAnswerHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintAnswerModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.deleteAnswerHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.disabelConfirm = true));
    },
    showError: function () {
      this.snackText = this.$store.state.chiefComplaintAnswerModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
